import {
  Checkbox,
  FormGroup,
  InputLabel,
  FormControlLabel,
} from '@mui/material';
import {
  targetAudiencesKeys,
  targetAudiencesRadioLabel,
} from 'constants/fields';
import { Controller } from 'react-hook-form';

export const TargetAudiencesField = ({ name, control, disabled }) => {
  const onChangeCheck = ({ e, value, onChange, onBlur }) => {
    onBlur(e);
    if (e.target.checked) return onChange([...(value || []), e.target.name]);

    const newValue = value?.filter(key => key !== e.target.name);

    onChange(newValue.length ? newValue : null);
  };

  const onCheckAll = ({ e, onChange }) => {
    if (e.target.checked) return onChange(Object.values(targetAudiencesKeys));

    onChange(null);
  };

  return (
    <Controller
      name={name}
      rules={{
        required: {
          value: true,
          message: 'Campo obrigatório',
        },
      }}
      control={control}
      render={({
        field: { onChange, onBlur, value = [] },
        fieldState: { error, isTouched },
      }) => {
        return (
          <FormGroup>
            <InputLabel className="form-label" htmlFor="name">
              Publico Alvo
            </InputLabel>
            <FormControlLabel
              disabled={disabled}
              name={targetAudiencesKeys.ALL}
              onBlur={onBlur}
              onChange={e => onCheckAll({ e, onChange, onBlur })}
              checked={Object.values(targetAudiencesKeys)?.every(key =>
                value?.includes(key)
              )}
              control={<Checkbox />}
              label="Todos"
            />
            {[
              targetAudiencesKeys.KIDS,
              targetAudiencesKeys.CHILDREN,
              targetAudiencesKeys.TEENAGER,
              targetAudiencesKeys.ADULT,
              targetAudiencesKeys.ELDERLY,
            ].map(targetAudiencesKey => (
              <FormControlLabel
                name={targetAudiencesKey}
                key={targetAudiencesKey}
                onBlur={onBlur}
                label={targetAudiencesRadioLabel[targetAudiencesKey]}
                disabled={disabled}
                control={<Checkbox />}
                checked={!!value?.includes(targetAudiencesKey)}
                onChange={e => onChangeCheck({ e, value, onChange, onBlur })}
              />
            ))}
            {error && isTouched ? (
              <div className="text-danger">
                <span>{'O campo é obrigatório!'}</span>
              </div>
            ) : null}
          </FormGroup>
        );
      }}
    />
  );
};
